import { createTypes, createAction } from "lib/action";
const LOAD_MASTERDATA_USER = createTypes("masterdatauser", "load");
const CREATE_MASTERDATA_USER = createTypes("masterdatauser", "create");
const LOAD_DETAILMASTERDATA_USER = createTypes("detailmasterdatauser", "load");
const LOAD_DETAILMASTERDATA_FOR_EDIT = createTypes("editdetailmasterdata", "load");
const UPDATE_MASTERDATA_USER = createTypes("masterdatauser", "update");
const REMOVE_LISTS = `REMOVE_LISTS`;

function removeLists() {
    return {
        type: REMOVE_LISTS
    };
}

const loadMasterUser = {
    request: (data, loading) =>
        createAction(LOAD_MASTERDATA_USER.REQUEST, { data, loading}),
    success: (lists, page) =>
        createAction(LOAD_MASTERDATA_USER.SUCCESS, {lists, page}),
    failure: () => createAction(LOAD_MASTERDATA_USER.FAITLURE)  
};

const createMasterUser = {
    request: (data, loading) =>
        createAction(CREATE_MASTERDATA_USER.REQUEST, { data, loading}),
    success: res => createAction(CREATE_MASTERDATA_USER.SUCCESS, { res }),
        failure: (error) => createAction(CREATE_MASTERDATA_USER.FAILURE, { error })
};

const loadDetailMasterUser = {
    request: (data, loading) =>
        createAction(LOAD_DETAILMASTERDATA_USER.REQUEST, { data, loading}),
    success: (lists, page) =>
        createAction(LOAD_DETAILMASTERDATA_USER.SUCCESS, {lists}),
    failure: () => createAction(LOAD_DETAILMASTERDATA_USER.FAITLURE)  
};

const loadDetailMasterDataForEdit = {
    request: (data, loading) =>
        createAction(LOAD_DETAILMASTERDATA_FOR_EDIT.REQUEST, {data, loading}),
    success: (lists) =>
        createAction(LOAD_DETAILMASTERDATA_FOR_EDIT.SUCCESS, {lists}),
    failure: () => createAction(LOAD_DETAILMASTERDATA_FOR_EDIT.FAITLURE)
};

const updateMasterDataUser = {
    request: (accessToken, data, loading) =>
        createAction(UPDATE_MASTERDATA_USER.REQUEST, { accessToken, data, loading}),
    success: res => createAction(UPDATE_MASTERDATA_USER.SUCCESS, { res }),
        failure: (error) => createAction(UPDATE_MASTERDATA_USER.FAILURE, { error })
}

export {
    LOAD_MASTERDATA_USER,
    loadMasterUser,
    createMasterUser,
    CREATE_MASTERDATA_USER,
    loadDetailMasterUser,
    LOAD_DETAILMASTERDATA_USER,
    LOAD_DETAILMASTERDATA_FOR_EDIT,
    loadDetailMasterDataForEdit,
    UPDATE_MASTERDATA_USER,
    updateMasterDataUser,
    REMOVE_LISTS,
    removeLists
};